import {Dispatch} from "redux";
import {GetMainPageText, UpdateMainPageText} from "../../../services/api-pages-config-service";
import {PagesConfigActionType} from "../../reducers/pagesConfigReducer/types";

export const GetMainPageTextAsync = () => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch({type: PagesConfigActionType.START_REQUEST});
            const data = await GetMainPageText();
            const {response} = data;
            dispatch({
                type: PagesConfigActionType.MAIN_PAGE_TEXT_LOADED,
                payload: JSON.stringify(response),
            });
        } catch (error) {
            console.error("An error occurred:", error);

            dispatch({
                type: PagesConfigActionType.FINISH_REQUEST,
                payload: "Error occurred",
            });
            throw error;
        }
    };
};

export const UpdateMainPageTextAsync = (text: string) => {
    return async (dispatch: Dispatch) => {
        dispatch({type: PagesConfigActionType.START_REQUEST});
        try {
            await UpdateMainPageText(text).then(() => { dispatch({
                type: PagesConfigActionType.MAIN_PAGE_TEXT_LOADED,
                payload: text,
            }) });
        } catch (error) {
            dispatch({
                type: PagesConfigActionType.FINISH_REQUEST,
                payload: "Error occurred",
            });

            throw error;
        }
    };
};